// areas
export const HOBBY_AREAS = [
  "Аксесуари для фотосесій",
  "Риболовля",
  "Туризм і кемпінг",
  "Музичні інструменти",
  "Рукоділля та творчість",
  "Колекціонування",
  "Інше",
];

// sections by area
const SECTIONS_BY_AREA = {
  "Аксесуари для фотосесій": [
    "Фотозони",
    "Декор для фотозон",
    "Фотобутафорія",
    "Обʼємні літери / Цифри",
  ],

  "Риболовля": [
    "Вудилища",
    "Котушки",
    "Ліски / Шнури",
    "Приманки",
    "Гачки / Фурнітура",
    "Годівниці / Снасті",
    "Аксесуари",
  ],

  "Туризм і кемпінг": [
    "Намети",
    "Спальні мішки / Каремати",
    "Складні меблі",
    "Термопродукція",
    "Туристичний посуд",
    "Мангал / Барбекю",
    "Ліхтарі / Освітлення",
  ],

  "Музичні інструменти": [
    "Гітари",
    "Клавішні",
    "Ударні",
    "Духові",
    "Смичкові",
    "Аксесуари / Обладнання",
  ],

  "Рукоділля та творчість": [
    "Вʼязання",
    "Шиття",
    "Вишивка",
    "Фурнітура для біжутерії",
    "Скрапбукінг",
    "Матеріали для рукоділля",
    "Миловаріння / Свічки",
    "Тканини",
    "Картини за номерами",
    "Малювання",
    "Флористика / Букети",
  ],

  "Колекціонування": [
    "Монети / Нумізматика",
    "Марки / Філателія",
    "Фігурки / Сувеніри",
    "Інше колекційне",
  ],

  "Інше": ["Інше хобі"],
};

// subcategories
const SUBCATS_BY_SECTION = {
  "Фотозони": [],
  "Декор для фотозон": [],
  "Фотобутафорія": [],
  "Обʼємні літери / Цифри": [],

  "Вудилища": ["Спінінгові", "Фідерні", "Поплавкові", "Інші"],
  "Котушки": ["Безінерційні", "Мультіплікаторні", "Інші"],
  "Ліски / Шнури": ["Монофільні", "Плетені (шнури)"],
  "Приманки": ["Воблери", "Блешні", "Мʼякі (силікон)"],
  "Гачки / Фурнітура": [],
  "Годівниці / Снасті": [],
  "Аксесуари": [],

  "Намети": [],
  "Спальні мішки / Каремати": [],
  "Складні меблі": [],
  "Термопродукція": [],
  "Туристичний посуд": [],
  "Мангал / Барбекю": [],
  "Ліхтарі / Освітлення": [],

  "Гітари": ["Акустичні", "Електрогітари", "Бас-гітари", "Укулеле"],
  "Клавішні": ["Синтезатори", "MIDI-клавіатури", "Піаніно/Цифрові"],
  "Ударні": ["Акустичні", "Електронні", "Перкусія"],
  "Духові": [],
  "Смичкові": [],
  "Аксесуари / Обладнання": [
    "Комбопідсилювачі",
    "Струни / Палки / Ремені",
    "Чохли / Стійки",
    "Тюнери / Метрономи",
    "Мікрофони / Інше",
  ],

  "Вʼязання": [],
  "Шиття": [],
  "Вишивка": [],
  "Фурнітура для біжутерії": [],
  "Скрапбукінг": [],
  "Матеріали для рукоділля": [],
  "Миловаріння / Свічки": [],
  "Тканини": [],
  "Картини за номерами": [],
  "Малювання": [],
  "Флористика / Букети": ["Квіткові", "Солодкі", "Пивні"],

  "Монети / Нумізматика": [],
  "Марки / Філателія": [],
  "Фігурки / Сувеніри": [],
  "Інше колекційне": [],
  "Інше хобі": [],
};

// fields
export const hobbyFields = (attrs) => {
  const a = attrs || {};
  const area = a.area || "";
  const section = a.section || "";

  const areaOnly = [
    {
      name: "area",
      label: "Сфера *",
      type: "select",
      options: HOBBY_AREAS,
      required: true,
    },
  ];
  if (!area) return areaOnly;

  const sectionOnly = [
    ...areaOnly,
    {
      name: "section",
      label: "Розділ",
      type: "select",
      options: SECTIONS_BY_AREA[area] || [],
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  const subcats = SUBCATS_BY_SECTION[section] || [];
  if (!subcats.length) return sectionOnly;

  return [
    ...sectionOnly,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: subcats,
      required: false,
    },
  ];
};
